export const redirectAfterSignIn = (url?: string) => {
  console.log('afterSignInHook', {
    redirectTo: localStorage.redirectTo,
  });
  if (localStorage.redirectTo) {
    let redirectToUrl = localStorage.redirectTo;
    if (url) {
      console.log(url);
      console.log(window.location.origin);
      const urlParams = new URL(url, window.location.origin).searchParams;
      console.log('urlParams', urlParams);
      const redirectUrl = new URL(
        localStorage.redirectTo,
        window.location.origin
      );
      urlParams.forEach((value, key) => {
        redirectUrl.searchParams.append(key, value);
      });
      redirectToUrl = redirectUrl.toString();
    }
    delete localStorage.redirectTo;
    window.location.href = redirectToUrl;
  }
};
